import type { INativeToken, IStoredToken } from "web/types/Token";

import decodeTokenExpiry from "./decodeTokenExpiry";
import persistToken from "./persistToken";

const persistNativeToken = (authSession: INativeToken): IStoredToken => {
  const { accessToken, idToken = "" } = authSession;
  const { exp, ttl } = decodeTokenExpiry(accessToken);
  const storedToken: IStoredToken = {
    token: accessToken,
    accessToken,
    idToken,
    exp,
    ttl,
  };

  persistToken(storedToken);

  return storedToken;
};

export default persistNativeToken;
